import { render } from "./CookieNotification.vue?vue&type=template&id=aea232ae&scoped=true"
import script from "./CookieNotification.vue?vue&type=script&lang=js"
export * from "./CookieNotification.vue?vue&type=script&lang=js"

import "./CookieNotification.vue?vue&type=style&index=0&id=aea232ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea232ae"]])

export default __exports__